<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Nuevo ciclo reina" />

        <v-text-field
                color="orange"
                label="Nombre de la reina*"
                v-bind:value="detailqueen.name"
                disabled
        ></v-text-field>

        <v-form ref="form" v-model="valid" lazy-validation>

            <v-select
                    v-model="infoform.idcolmenar"
                    class="form-group"
                    color="orange"
                    :items="colmenares"
                    item-value="[id]"
                    item-text="[name]"
                    label="Colmenar*"
                    data-vv-name="infoform.idcolmenar"
                    v-on:change="onChange"
                    required
                    :rules="requiredRule"
            ></v-select>

            Solo se muestran las colmenas/núcleo que no tienen reina del colmenar seleccionado.
            <v-select
                    v-model="infoform.idcolmena"
                    class="form-group"
                    color="orange"
                    :items="listColmenas"
                    item-value="[id]"
                    item-text="[number]"
                    label="Colmena/núcleo*"
                    data-vv-name="infoform.idcolmena"
                    required
                    :rules="requiredRule"
            ></v-select>


            <p class="v-messages__message">{{errors.idcolmenar}}</p>


            <p for="date" style="font-size:0.69rem;"><b>Fecha de inicio ciclo*</b></p>
            <datepicker
                    style="margin-bottom:20px;"
                    name="date"
                    id="date"
                    v-model="infoform.date"
                    format="dd/MM/yyyy"
                    class="form-datepicker"></datepicker>

            <p class="v-messages__message">{{errors.date}}</p>

            <v-select
                    v-model="infoform.cycle"
                    class="form-group"
                    color="orange"
                    :items="optionsCycle"
                    label="Ciclo"
                    data-vv-name="infoform.cycle"
            ></v-select>


            <v-select
                    v-model="infoform.state"
                    class="form-group"
                    color="orange"
                    :items="optionsState"
                    label="Estado"
                    data-vv-name="infoform.state"
            ></v-select>


            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>


            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Crear ciclo
            </v-btn>

        </v-form>


    </div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"

import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/dist/locale'


export default {

    name: 'ciclo-reina-editar',
    components: {
        toolbar,
        loading,
        Datepicker
    },
    data: () => ({

            toolbar: {
                return: '0'
            },

            valid: true,

            requiredRule: [
                v => !!v || 'Requerido',
            ],

            isloading:'',

            es: es,

            errors: {
                idcolmenar: '',
                date:'',
            },

            alertForm:'success',
            responseform:'',
            alert: false,


            optionsCycle: [
              { text: 'Operculada', value: 'operculada' },
              { text: 'Eclosión', value: 'eclosion' },
              { text: 'Fecundación', value: 'fecundacion' },
              { text: 'Madura', value: 'madura' },
              { text: 'Vieja', value: 'vieja' },
              { text: 'Muerta', value: 'muerta' }
            ],

            optionsState: [
              { text: 'Introducida', value: 'introducida' },
              { text: 'Aceptada', value: 'aceptada' },
              { text: 'Rechazada', value: 'rechazada' },
              { text: 'Transferida', value: 'transferida' },
              { text: 'Vendida', value: 'vendida' },
              { text: 'Sustituida', value: 'sustituida' },
              { text: 'Enjambrada', value: 'enjambrada' },
              { text: 'Perdida', value: 'perdida' },
              { text: 'Otro', value: 'otro' }
            ],

            listColmenas:[],

            infoform: {
                idqueen: '',
                idcolmenar: '',
                idcolmena: '0',
                date: (1 + new Date().getMonth()).toString() + '/' + new Date().getDate().toString() +'/' + new Date().getFullYear(),
                cycle: 'operculada',
                state: 'introducida',
            },

            info: null,
            detailqueen: null,
            colmenares: null,
            colmenar:null
  }),
  created() {
    auth.getUserLogged()

    this.getTodos();
  },
  methods:{

        async getTodos(){


            var that = this

            await axios.get("https://appws.panimiel.com/new/index.php/api/colmenar").then((colmenares) => {
              that.colmenares = colmenares.data
            })

            await axios.get("https://appws.panimiel.com/new/index.php/api/queens/"+this.$route.params.id).then((detailqueen) => {
              that.detailqueen = detailqueen.data
              that.infoform.idqueen = that.detailqueen.id


              that.infoform.idcolmenar = that.detailqueen.idcolmenar


              if(that.detailqueen.idcolmena!=null){

                that.infoform.idcolmena = that.detailqueen.idcolmena


              }else{
                that.infoform.idcolmena = '0'
              }

            //  alert(this.infoform.idcolmenar+'/'+this.infoform.idcolmena)

            })

            axios.get('https://appws.panimiel.com/new/index.php/api/colmena/no_queen/'+this.infoform.idcolmenar+'/'+that.infoform.idcolmena)
            .then(function (response) {

              that.listColmenas = response.data;
            })
        },

        validate () {
            this.$refs.form.validate()
            if(this.infoform.date===''){
                    this.errors.date = "Debes insertar la fecha de inicio del ciclo."
            }
            if(this.$refs.form.validate()){
                this.errors.date = ''
                this.alert = false
                this.isloading = true

                if(this.infoform.date===''){
                    this.isloading = false
                    this.errors.date = "Debes insertar la fecha de inicio del ciclo."
                }else{

                    this.errors.idcolmenar = ''

                    axios.post('https://appws.panimiel.com/new/index.php/api/queens_cycle', this.infoform).then((response) => {
                        this.responseform = response.data
                         this.alertForm = 'success'
                         this.isloading=''
                         this.alert = true
                    })
                    .catch((error) => {
                        this.alertForm = 'error',
                        this.isloading=''

                        if (error.response.status != 500){
                            this.responseform = error.response.data
                        }else{
                            this.responseform = 'Error, no ha sido posible insertar el ciclo de la reina.'
                        }
                         this.alert = true

                     })
                }
            }

        },
        onChange: function (){
            var self = this

           axios.get('https://appws.panimiel.com/new/index.php/api/colmena/no_queen/'+this.infoform.idcolmenar+'/'+this.infoform.idcolmena)
            .then(function (response) {
              self.listColmenas = response.data;

              if(self.listColmenas.length < 1){
                self.infoform.idcolmena = ''
                self.errors.idcolmenar = "No hay colmenas para el colmenar seleccionado."
              }else{
                self.errors.idcolmenar = ""
              }
            })
         }
    }


};


</script>

<style scoped lang="scss">
</style>